<template>
    <div :class="['report-result', $i18n.locale]">
        <div class="shape-title" v-if="name !== null">
            <span>{{ name }}</span>
        </div>
        <div class="result-wrapper" v-if="!canvas">
            <div class="result-box" v-if="title !== null">
                {{ title }}
                <span
                    v-if="title == $t('yao_tun_bi')"
                >{{ $t('zheng_chang_fan_wei')}}{{ sex === 2 ?'0.75~0.80' : '0.85~0.90' }}</span>
            </div>
            <div class="comparison-list-box1" v-for="(item, index) in arr" :key="index">
                <div v-if="showGirthData(item)">
                    <p class="item-lang">{{ item.title }}</p>
                    <div class="comparison-list">
                        <div class="comparison-list-first">
                            <div v-if="item.lastvalue != 0">
                                <span v-if="item.lastvalue">
                                    <span class="comparison-list-span" v-if="item.title === $t('bei_bu_ti_ji')">
                                        {{
                                        toDecimal(item.lastvalue, 1) > 0 ? unit1 === 'metric' ? toDecimal(item.lastvalue, 2) : toDecimal(item.lastvalue, 1) : '-'
                                        }}
                                    </span>
                                    <span class="comparison-list-span" v-else-if="title !== $t('yao_tun_bi')">
                                        {{
                                        toDecimal(item.lastvalue, 1) > 0 ? toDecimal(item.lastvalue, 1) : '-'
                                        }}
                                    </span>
                                    <span class="comparison-list-span" v-else>
                                        {{
                                        toDecimal(item.lastvalue, 2) > 0 ? toDecimal(item.lastvalue, 2) : '-'
                                        }}
                                    </span>
                                </span>
                                <span v-else class="comparison-list-span" style="color: #8aa3be">--</span>
                                <span>{{ unit }}</span>
                            </div>
                            <div v-else>
                                <span class="comparison-list-span">--</span>
                                <span>{{ unit }}</span>
                            </div>
                        </div>
                        <!-- 体围数据数据对比 -->
                        <div class="comparison-list-second">
                            <div v-if="item.lastvalue != 0">
                                <img
                                    v-if="item.value - item.lastvalue == 0"
                                    src="@/assets/images/waist/icon1_just.png"
                                    alt
                                />
                                <img
                                    v-else-if="item.value - item.lastvalue > 0"
                                    src="@/assets/images/waist/icon1_rise.png"
                                    alt
                                />
                                <img v-else src="@/assets/images/waist/icon1_decline.png" alt />
                                <span v-if="item.title === $t('bei_bu_ti_ji')">
                                    {{
                                    item.value > 0 && item.lastvalue > 0 ? unit1 === 'metric' ?toDecimal(Math.abs((item.value - item.lastvalue).toFixed(2)), 2) :toDecimal(Math.abs((item.value - item.lastvalue).toFixed(1)), 1) : '-'}}
                                </span>
                                <span v-else-if="title !== $t('yao_tun_bi')">
                                    {{
                                    item.value > 0 && item.lastvalue > 0 ? toDecimal(Math.abs((item.value - item.lastvalue).toFixed(1)), 1) : '-'}}
                                </span>
                                <span v-else>
                                    {{
                                    item.value > 0 && item.lastvalue > 0 ? toDecimal(Math.abs((item.value - item.lastvalue).toFixed(2)), 2) : '-'}}
                                </span>
                            </div>
                            <div v-else>
                                <span class="comparison-none">--</span>
                            </div>
                        </div>
                        <!-- 体围数据最新数据 -->
                        <div class="comparison-list-first">
                            <span v-if="item.value">
                                <span class="comparison-list-span" v-if="item.title === $t('bei_bu_ti_ji')">
                                    {{
                                    toDecimal(item.value, 1) > 0 ? unit1 === 'metric' ? toDecimal(item.value, 2) :toDecimal(item.value, 1) : '-'
                                    }}
                                </span>
                                <span class="comparison-list-span" v-else-if="title !== $t('yao_tun_bi')">
                                    {{
                                    toDecimal(item.value, 1) > 0 ? toDecimal(item.value, 1) : '-'
                                    }}
                                </span>
                                <span class="comparison-list-span" v-else>
                                    {{
                                    toDecimal(item.value, 2) > 0 ? toDecimal(item.value, 2) : '-'
                                    }}
                                </span>
                            </span>
                            <span v-else class="comparison-list-span1" style="color: #8aa3be">--</span>
                            <span>{{ unit }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="result-wrapper" v-else>
            <div class="result-box" v-if="title !== null">{{ title }}</div>
            <div class="result-wrapper2">
                <span class="pang-title pang-hou" style="top: 6vw">{{$t('waist.hou')}}</span>
                <span class="pang-title" style="top: 19vw">{{$t('waist.qian')}}</span>
                <span
                    class="pang-title pang-hou"
                    :style="{'top': size($i18n.locale)}"
                    v-if="arr.length > 3"
                >{{$t('waist.hou')}}</span>
                <span
                    class="pang-title"
                    :style="{'top': size2($i18n.locale)}"
                    v-if="arr.length > 3"
                >{{$t('waist.qian')}}</span>
                <div class="waist-canvas-box">
                    <div class="waist-box-item" v-for="(item, index) in arr" :key="index + 'rr'">
                        <waist-canvas :arr="item"></waist-canvas>
                        <ul class="custom-bullet-list">
                            <li>{{ $t('shang_ci') }}{{ item.lastvalue > 0 ? toDecimal(item.lastvalue, 1) : '-' }}</li>
                            <li>{{ $t('ben_ci') }}{{ item.value > 0 ? toDecimal(item.value, 1) : '-' }}</li>
                        </ul>
                        <p class="custom-p">{{item.title}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { _toDecimal } from '@/assets/js/util.js'
import WaistCanvas from '@/components/common/Waistcanvas.vue'
export default {
    components: {
        WaistCanvas,
    },
    props: {
        name: {
            type: String,
            default: null,
        },
        arr: {
            type: Array,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        unit: {
            type: String,
            default: null,
        },
        canvas: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modelInfo: JSON.parse(window.localStorage.getItem('modelInfo')),
            sex: JSON.parse(window.localStorage.getItem('memberInfo')).sex,
            unit1: window.localStorage.getItem('unit'),
        }
    },
    methods: {
        toDecimal(num, digit) {
            return _toDecimal(num, digit)
        },
        showGirthData(item) {
            return item.width !== 0
        },
        size(lang) {
            return lang === 'el-GR'
                ? '65vw'
                : lang === 'es-ES' ||
                  lang === 'it-IT' ||
                  lang === 'fr-FR' ||
                  lang === 'ru-RU' ||
                  lang === 'pt-PT' ||
                  lang === 'id-ID' ||
                  lang === 'pt-PTO' ||
                  lang === 'fi-FI'
                ? '59vw'
                : '52vw'
        },
        size2(lang) {
            return lang === 'el-GR'
                ? '77vw'
                : lang === 'es-ES' ||
                  lang === 'it-IT' ||
                  lang === 'fr-FR' ||
                  lang === 'ru-RU' ||
                  lang === 'pt-PT' ||
                  lang === 'id-ID' ||
                  lang === 'pt-PTO' ||
                  lang === 'fi-FI'
                ? '71vw'
                : '65vw'
        },
    },
}
</script>

<style lang="less" scoped>
.report-result {
    margin: 15px 15px 0 11px;
    font-family: PingFangSC, PingFang SC;

    .shape-title {
        width: 100px;
        height: 28px;
        margin-bottom: -2px;
        line-height: 26px;
        color: #222222;
        font-family: PingFangSC, PingFang SC;
        background: url(../../assets/images/waist/shape_over_en.png) center no-repeat;
        background-size: 100% 100%;
        text-align: center;

        span {
            letter-spacing: 0.2px;
            width: 98px;
            height: 14px;
            // margin-left: 5px;
            font-size: 14px;
        }
    }

    .result-wrapper {
        width: 353px;
        background: url(../../assets/images/waist/waistbg1.png) center no-repeat;
        background-size: 100% 100%;
        // border: white 1px solid;
        color: #8aa3be;
        .result-wrapper2 {
            width: 353px;
            // height: 410px;
            background-size: 100% 100%;
            // border: white 1px solid;
            color: #8aa3be;
            position: relative;
        }
    }

    .result-box {
        text-align: left;
        padding: 10px 15px;
        // opacity: 0.2;
    }
}
.custom-p {
    width: 100px;
    font-size: 13px;
    margin-top: 10px;
}

&.en-US,
&.sv-SE,
&.hu-HU,
&.pl-PL {
    .shape-title {
        width: 200px;
    }
}
&.it-IT,
&.fr-FR {
    .shape-title {
        width: 120px;
    }
}
.comparison-list-box1 {
    position: relative;
    margin: 0 10px;
    overflow: hidden;

    p {
        width: 215px;
        margin: 12px auto 4px;
        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }

    &::before {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: #ffffff;
        opacity: 0.2;
    }
}

.comparison-list {
    //   min-height: 70px;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
    position: relative;

    .comparison-list-first {
        width: 42.33%;

        span {
            display: inline-block;
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #8aa3be;
            line-height: 12px;
        }

        .comparison-list-span {
            background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            display: inline-block;
        }

        .comparison-list-span1 {
            // line-height: 70px;
            font-size: 22px;
        }

        .comparison-list-none,
        .comparison-list-span {
            display: inline-block;
            font-size: 22px;
            font-family: PingFangSC, PingFang SC;
            line-height: 22px;
            // line-height: 70px;
        }
    }

    .comparison-list-second {
        // margin-top: 17px;
        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        color: #ffffff;
        line-height: 15px;
        width: 33.33%;

        div {
            margin-top: 4px;

            img {
                display: inline-block;
                margin-top: 2px;
                width: 14px;
                height: 14px;
                position: relative;
                top: 2px;
            }

            span {
                font-size: 13px;
                font-family: PingFangSC, PingFang SC;
                color: #8aa3be;
                line-height: 13px;
            }
        }

        .comparison-none {
            line-height: 20px;
        }
    }
}
.pang-title {
    // writing-mode: vertical-rl;
    position: absolute;
    left: 16px;
    // height: 150px;
}
&.ar-AR {
    .result-box {
        text-align: right;
    }
    .shape-title {
        transform: scaleX(-1);
    }
    .result-wrapper {
        direction: ltr;
        .comparison-list-first {
            direction: rtl;
        }
    }
}
.item-lang {
    text-align: center !important;
    margin-right: auto !important;
}
&.ru-RU,
&.id-ID {
    .waist-canvas-box {
        width: 340px;
    }
    .waist-box-item {
        .custom-bullet-list {
            padding-left: 20px !important;
        }
        p {
            width: 100px !important;
        }
    }
}
&.id-ID {
    .waist-box-item {
        .custom-bullet-list {
            padding-left: 10px !important;
        }
    }
    .waist-canvas-box {
        padding-left: 40px;
    }
    .pang-hou {
        top: 210px;
    }
}
&.tr-TR,
&.th-TH,
&.ar-AR {
    .waist-box-item {
        .custom-bullet-list {
            padding-left: 20px !important;
        }
    }
}
&.cs-CZ {
    .waist-box-item {
        .custom-bullet-list {
            padding-left: 10px !important;
        }
    }
}
&.el-GR {
    .waist-box-item {
        .custom-bullet-list {
            padding-left: 10px !important;
            // list-style-position: inside;
        }
    }
}
&.ar-AR {
    .result-wrapper .custom-p {
        margin-right: 0 !important;
    }
}
&.hu-HU {
    .result-wrapper .waist-box-item .custom-p {
        font-size: 12px !important;
    }
}
.waist-canvas-box {
    width: 330px;
    background: url(../../assets/images/waist/waistlbg.png) center top no-repeat,
        url(../../assets/images/waist/waistlbg.png) center 180px no-repeat;
    // background-size: 100% 100%;
    // border: white 1px solid;
    // background-repeat: repeat-y;
    background-size: 100% 140px, 100% 140px;
    color: #8aa3be;
    // margin-left: 40px;
    margin-left: 11px;
    padding-left: 25px;
    display: flex;
    justify-content: space-between; /* 控制子元素在主轴上的间距 */
    align-items: flex-start; /* 控制子元素在交叉轴上的对齐方式 */
    flex-wrap: wrap;
    .waist-box-item {
        width: 100px;
        height: 180px;
        margin: 0px !important;
        flex: 1 1 calc(33.333% - 12px);
        // border-top: 1px solid #444A7A;

        .custom-bullet-list {
            list-style-type: disc; /* 确保使用小圆点 */
            padding-left: 20px; /* 根据需要调整缩进 */
            // border-bottom: 1px solid #444A7A;
        }

        .custom-bullet-list li:first-child::marker {
            color: #f05656; /* 设置小圆点的颜色 */
        }
        .custom-bullet-list li:last-child::marker {
            color: #00e3c9; /* 设置小圆点的颜色 */
        }
        .custom-bullet-list li:first-child {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #f05656;
            line-height: 17px;
            text-align: left;
            font-style: normal;
        }
        .custom-bullet-list li:last-child {
            color: #00e3c9; /* 设置小圆点的颜色 */
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            text-align: left;
            font-style: normal;
        }
    }
}
&.ja-JP {
    .waist-canvas-box {
        background: url(../../assets/images/waist/waistlbg.png) center top no-repeat,
            url(../../assets/images/waist/waistlbg.png) center 190px no-repeat;
        background-size: 100% 140px, 100% 140px;
    }
    .waist-box-item {
        height: 190px;
    }
}
&.es-ES,
&.it-IT,
&.fr-FR,
&.ru-RU,
&.pt-PT,
&.id-ID,
&.pt-PTO,
&.en-US,
&.pl-PL {
    .waist-canvas-box {
        background: url(../../assets/images/waist/waistlbg.png) center top no-repeat,
            url(../../assets/images/waist/waistlbg.png) center 200px no-repeat;
        background-size: 100% 140px, 100% 140px;
    }
    .waist-box-item {
        height: 200px;
    }
}
&.el-GR {
    .waist-canvas-box {
        background: url(../../assets/images/waist/waistlbg.png) center top no-repeat,
            url(../../assets/images/waist/waistlbg.png) center 220px no-repeat;
        background-size: 100% 140px, 100% 140px;
    }
    .waist-box-item {
        height: 220px;
    }
}
&.fi-FI {
    .waist-canvas-box {
        background: url(../../assets/images/waist/waistlbg.png) center top no-repeat,
            url(../../assets/images/waist/waistlbg.png) center 190px no-repeat;
        background-size: 100% 140px, 100% 140px;
    }
    .waist-box-item {
        margin-left: 10px;
        height: 190px;
        div {
            margin-left: 10px;
            height: 100px;
        }
    }
}
</style>
